import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["javaAddress", "bedrockAddress"]

  connect() {
    // バリデーションエラーがある場合、対応するアドレス欄を強制表示
    this.forceShowOnError("java")
    this.forceShowOnError("bedrock")
  }

  toggle({ params: { edition } }) {
    const target = edition === "java" ? this.javaAddressTarget : this.bedrockAddressTarget
    const checkbox = this.element.querySelector(`input[type="checkbox"][name*="${edition}_edition"]`)
    const group = target.closest(".edition-address-group")

    if (checkbox.checked) {
      target.style.display = ""
      group.classList.add("edition-address-group--active")
      // アドレス入力欄にフォーカス
      const input = target.querySelector("input[type=text]")
      if (input) requestAnimationFrame(() => input.focus())
    } else {
      target.style.display = "none"
      group.classList.remove("edition-address-group--active")
      target.querySelector("input[type=text]").value = ""
    }
  }

  forceShowOnError(edition) {
    const target = edition === "java" ? this.javaAddressTarget : this.bedrockAddressTarget
    const hasError = target.querySelector(".form-error")
    if (hasError) {
      const checkbox = this.element.querySelector(`input[type="checkbox"][name*="${edition}_edition"]`)
      if (checkbox) checkbox.checked = true
      target.style.display = ""
      target.closest(".edition-address-group").classList.add("edition-address-group--active")
    }
  }
}
